import { IconPawPrint } from '@madpaws/design-system';
import React from 'react';

import styles from './Banner.module.css';

import type { ReactElement } from 'react';

export type ReminderProps = {
  description?: string;
  icon?: string;
  title?: string;
};

export const Banner = ({ title, description, icon = 'paw' }: ReminderProps): ReactElement => {
  const renderIcon = (): ReactElement => {
    if (icon === 'paw') {
      return <IconPawPrint size="medium" />;
    }

    return <></>;
  };

  return (
    <div className={styles.root}>
      <div className={styles.icon}>{renderIcon()}</div>
      <div className={styles.content}>
        {title && <span className={styles.title}>{title}</span>}
        <span className={`${styles.description} ${title && styles.smallerTextSize}`}>
          {description}
        </span>
      </div>
    </div>
  );
};
